import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { RootStore } from "../../../store/Store";
import { Button } from "../../atoms";
import "./modal.css";

interface Props {
  show: boolean;
  type?: string;
  handleClose: () => void;
}
interface TitleSpanProps {
  type?: string;
}

const TitleSpan = styled.span<TitleSpanProps>`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: right;
  color: ${(p) =>
    p.type === "error" ? (theme: any) => theme.theme.bgRed ?? "red" : p.type === "warning" ? "yellow" : (theme: any) => theme.theme.bgPrimary ?? "blue"};
`;
const DescSpan = styled.span`
  width: 80%;
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(theme: any) => theme.theme.white};
`;

const AlertModal = (props: Props) => {
  const { t } = useTranslation();
  const AlertState = useSelector((state: RootStore) => state.alert);
  const showHideClassName = AlertState.alert.show
    ? "modal display-block"
    : "modal display-none";

  useEffect(() => {
    if (AlertState.alert.show) {
      setTimeout(() => {
        let a = document.getElementById("test")?.firstChild as HTMLElement;
        a.focus();
      }, 100);
    }
  }, [AlertState.alert.show]);
  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        <TitleSpan type={AlertState.alert.type}>
          {t(AlertState.alert.title)}
        </TitleSpan>
        <DescSpan>{t(AlertState.alert.message)}</DescSpan>
        <div id="test">
          <Button
            id="116"
            primary={true}
            backgroundColor={"blue"}
            text={AlertState.alert.btnText ? t(AlertState.alert.btnText) : "ok"}
            color={"white"}
            onClick={props.handleClose}
          ></Button>
        </div>
      </section>
    </div>
  );
};

export default AlertModal;
